import {
    createBaseQueries,
    transformErrorResponse,
    transformSuccessResponse,
    EXTERNAL_URL,
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const { rawExternalApiBaseQuery: notificationBaseQuery } = createBaseQueries({
    externalURLType: EXTERNAL_URL.appRoot,
});

const NotificationAPI = createApi({
    reducerPath: 'NotificationAPI',
    baseQuery: notificationBaseQuery,
    tagTypes: ['Notification'],
    endpoints: (builder) => ({

        getStudentNotificationList: builder.query({
            query: ({ page = 0, size = 10, searchText = '', sortBy = 'id', sortDir = 'asc' } = {}) => ({
                url: `/util/notification`,
                method: 'GET',
                params: { page, size, searchText, sortBy, sortDir },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            providesTags: ['Notification'],
        }),

    }),
});

export const {
    useGetStudentNotificationListQuery,
    useLazyGetStudentNotificationListQuery,
} = NotificationAPI;

export default NotificationAPI;
